import { Box, FormControl, Option, Select } from "@mui/joy";
import { useEffect, useState } from "react";
import { IStatoLavorazione } from "../../../models";
import { EOptionType, IFilterOption } from "../../../models/utlis";
import { useTranslation } from "react-i18next";

interface ISelectLottoFiltersProps {
  lavorazioni: IStatoLavorazione[];
  spessoriDisponibili: number[];
  filters: IFilterOption[];
  onSetFilters: (filters: IFilterOption[]) => void;
}

export default function SelectLottoFilterV2({
  spessoriDisponibili,
  lavorazioni,
  filters,
  onSetFilters,
}: ISelectLottoFiltersProps) {
  const { i18n, t } = useTranslation();
  const [selectedLavorazione, setSelectedLavorazione] = useState<string | null>(
    null
  );
  const [selectedSpessore, setSelectedSpessore] = useState<string | null>(null);

  const onChangeLavorazione = (
    _event:
      | React.MouseEvent<Element, MouseEvent>
      | React.KeyboardEvent<Element>
      | React.FocusEvent<Element, Element>
      | null,
    value: string | null
  ) => {
    const _filters = [...filters].filter(
      (opt) => !(opt.type === EOptionType.statoLavorazione)
    );
    if (value) {
      onSetFilters([
        ..._filters,
        {
          type: EOptionType.statoLavorazione,
          numericValue: parseInt(value),
        },
      ]);
    } else {
      onSetFilters(_filters);
    }
  };
  const onSelectedSpessore = (
    _event:
      | React.MouseEvent<Element, MouseEvent>
      | React.KeyboardEvent<Element>
      | React.FocusEvent<Element, Element>
      | null,
    value: string | null
  ) => {
    const _filters = [...filters].filter(
      (opt) => !(opt.type === EOptionType.misZ)
    );
    if (value) {
      onSetFilters([
        ..._filters,
        {
          type: EOptionType.misZ,
          numericValues: [parseFloat(value), parseFloat(value)],
        },
      ]);
    } else {
      onSetFilters(_filters);
    }
  };

  useEffect(() => {
    const finitura =
      filters.find((filter) => filter.type === EOptionType.statoLavorazione)
        ?.numericValue ?? "";
    const misZArray =
      filters.find((filter) => filter.type === EOptionType.misZ)
        ?.numericValues ?? "";

    setSelectedLavorazione(finitura ? finitura.toString() : null);
    setSelectedSpessore(misZArray?.[0] ? misZArray[0].toString() : null);
  }, [filters]);

  return (
    <Box sx={{ display: "flex", gap: 1, px: 2, flexWrap: "wrap" }}>
      <FormControl sx={{ py: 1 }}>
        <Select
          placeholder={t("Finish").toUpperCase()}
          variant="plain"
          value={selectedLavorazione}
          onChange={onChangeLavorazione}
        >
          <Option value="">---</Option>
          {lavorazioni.map((lavorazione) => {
            const lavorazioneNome =
              i18n.language === "en" && lavorazione.nomeEn
                ? lavorazione.nomeEn
                : lavorazione.nome;
            return (
              <Option key={lavorazione.id} value={lavorazione.id.toString()}>
                {lavorazioneNome}
              </Option>
            );
          })}
        </Select>
      </FormControl>
      <FormControl sx={{ py: 1 }}>
        <Select
          placeholder={t("Thickness").toUpperCase()}
          variant="plain"
          value={selectedSpessore}
          onChange={onSelectedSpessore}
        >
          <Option value="">---</Option>
          {spessoriDisponibili.map((misZ) => (
            <Option key={misZ} value={misZ.toString()}>
              {misZ}
            </Option>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
